export const Backdrops = [
  { name: "Resident Evil 2", gameId: "19686" },
  { name: "Firewatch", gameId: "9730" },
  { name: "NieR:Automata", gameId: "11208" },
  { name: "The Elder Scrolls V: Skyrim", gameId: "472" },
  { name: "Red Dead Redemption 2", gameId: "25076" },
  { name: "Horizon Zero Dawn", gameId: "11156" },
  { name: "Nioh", gameId: "12571" },
  { name: "Hellblade: Senua's Sacrifice", gameId: "7603" },
  { name: "Halo 4", gameId: "991" },
  { name: "The Witness", gameId: "5601" },
  { name: "The Witcher 3: Wild Hunt", gameId: "22439" },
  { name: "Bloodborne", gameId: "7334" },
  { name: "The Banner Saga", gameId: "5508" },
  { name: "RAGE 2", gameId: "101211" },
  { name: "Marvel's Spider-Man", gameId: "19565" },
  { name: "Mario + Rabbids Kingdom Battle", gameId: "28414" }
];
